let pesanTertunda: string | null = null;

export function simpanPesanLogin(pesan: string): void {
  pesanTertunda = pesan;
}

export function ambilPesanLogin(): string | null {
  const pesan = pesanTertunda;
  pesanTertunda = null;
  return pesan;
}
